var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSceneFrameWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1123,
    height: 522,
    viewBox: "0 0 1123 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.245C0 15.8733 19.588 -1.43983 41.7941 1.27757C139.682 13.2563 388.584 41.4688 561.5 41.4688C734.416 41.4688 983.318 13.2563 1081.21 1.27758C1103.41 -1.43982 1123 15.8733 1123 38.245V483.755C1123 506.127 1103.41 523.44 1081.21 520.722C983.318 508.744 734.416 480.531 561.5 480.531C388.584 480.531 139.682 508.744 41.7941 520.722C19.5881 523.44 0 506.127 0 483.755V38.245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSceneFrameWhite);
export default __webpack_public_path__ + "static/media/scene-frame-white.35dbb06cb8018a714b68082e144b4b87.svg";
export { ForwardRef as ReactComponent };